import React, { useEffect } from "react";
import { string, number } from "prop-types";
import { scriptLoader } from "../index";

const MetypeCommentsWidget = (props) => {
  const {
    primaryColor,
    host = "https://www.metype.com",
    accountId,
    className,
    secondaryColor,
    fontColor,
    pageURL,
    windowHeight,
    windowWidth,
    fontUrl,
    fontFamily,
    message = null,
    jwt,
    storyId,
  } = props;
  const randomNumber = storyId;

  useEffect(() => {
    !window.talktype && scriptLoader(host, () => initWidget(randomNumber));
    initWidget(randomNumber);
  }, []);

  useEffect(() => {
    if (window.talktype && message !== null) {
      window.talktype.accountUserLogout();
      initWidget(randomNumber);
    }
  }, [message]);

    // Handle JWT changes (for login after widget is loaded)
  useEffect(() => {
    if (window.talktype && jwt && !message) {
      window.talktype.accountUserLogin({
        jwt: jwt,
      });
    }
  }, [jwt, message]);

  const initWidget = (randomNumber) => {
    if (window.talktype) {
      jwt &&
        !message &&
        window.talktype.accountUserLogin({
          jwt: jwt,
        });
      window.talktype.commentWidgetIframe(document.getElementById(`metype-container-${randomNumber}`));
    }
  };

  return (
    <div>
      <div
        id={`metype-container-${randomNumber}`}
        className={`iframe-container ${className}`}
        data-metype-account-id={accountId}
        data-metype-host={host}
        data-metype-primary-color={primaryColor || "#c6554f"}
        data-metype-bg-color={secondaryColor || "#ffffff"}
        data-metype-font-color={fontColor || "#000000"}
        data-metype-window-width={windowWidth || (!global ? window.screen.width : 700)}
        data-metype-window-height={windowHeight || (!global ? window.screen.height : 700)}
        data-metype-page-url={pageURL}
        data-metype-font-url={fontUrl || ""}
        data-metype-font-family={fontFamily || "Roboto Slab"}
      ></div>
    </div>
  );
};

MetypeCommentsWidget.propTypes = {
  primaryColor: string,
  host: string,
  accountId: string,
  className: string,
  secondaryColor: string,
  fontColor: string,
  pageURL: string,
  windowHeight: number,
  windowWidth: number,
  fontUrl: string,
  fontFamily: string,
  message: string,
  jwt: string,
  storyId: string,
};

export { MetypeCommentsWidget };
